/**
 * Redesign — collapsible header search (mobile).
 *
 * The theme's <store-header> already owns the open/close state: clicking
 * `.js-show-search` toggles `search-is-collapsed` / `search-is-visible` on the
 * host element, and custom.css animates off those classes. This file only adds
 * the two things the theme leaves out:
 *
 *   1. `aria-expanded` on the toggle, kept in sync with the real state.
 *   2. Escape closes the search bar and returns focus to the toggle — but only
 *      once the predictive-search panel is shut, since predictive-search.js
 *      uses Escape to close its own results first.
 */
(() => {
  const header = document.querySelector('store-header[data-is-search-minimised]');
  if (!header) return;

  const toggles = header.querySelectorAll('.js-show-search, .js-show-search-left');
  if (!toggles.length) return;

  const isOpen = () => !header.classList.contains('search-is-collapsed');

  // The toggle that is actually on screen at this breakpoint (the markup can
  // render both a mobile and a desktop one, each hidden at the other's width).
  const visibleToggle = () => Array.from(toggles).find((el) => el.offsetParent !== null);

  const syncState = () => {
    const open = isOpen() ? 'true' : 'false';
    toggles.forEach((el) => el.setAttribute('aria-expanded', open));
  };

  new MutationObserver(syncState).observe(header, {
    attributes: true,
    attributeFilter: ['class'],
  });
  syncState();

  header.addEventListener('keydown', (evt) => {
    if (evt.key !== 'Escape' || !isOpen()) return;

    // Let predictive-search close its results panel on this keypress.
    if (header.querySelector('predictive-search[open]')) return;

    const toggle = visibleToggle();
    if (!toggle) return;

    evt.preventDefault();
    toggle.click();
    toggle.focus();
  });
})();
